import React, { useCallback, useEffect, useState } from "react"
import styles from "./styles.module.css";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { ReactComponent as WifiIcon } from "../../../assets/wifi-icon.svg"
import { ReactComponent as NoInternetIcon } from "../../../assets/no-internet-with-label-icon.svg"
import { ReactComponent as WeakInternetIcon } from "../../../assets/weak-internet-with-lablel-icon.svg"
import { ReactComponent as GuideIcon } from "../../../assets/quick-guide-icon.svg"
import { ReactComponent as SettingIcon } from "../../../assets/setting-icon.svg";
import { ReactComponent as GoldTrophyIcon } from "../../../assets/gold-trophy-icon.svg";
import QuickGuideBottomsheet from "./QuickGuideBottomsheet";
import PrizePoolBottomsheet from "./PrizePoolBottomsheet";
import { useNetworkStatus } from "../../../context/NetworkProvider";
import SettingsBottomsheet from "./SettingBottomsheet/SettingBottomsheet";
import LeaveTableBottomsheet from "./LeaveTableBottomsheet";
import { useSelector } from "react-redux";
import { getPrizePot, getRoundNumber } from "../store/actions";
import { _isNil } from "../../../utils/helpers/zupeeLodash";
import { RUPEES_SYMBOL } from "../../../utils/helpers/constants";
import { handleLeaveGame } from "../../../store/actions/ludoboardActions";

const GameplayHeader: React.FC = () => {
  const { t } = useTranslation();
  const { status } = useNetworkStatus();
  const normalizedStatus = status.trim().toLowerCase();
  const prizePot = useSelector(getPrizePot)
  const roundNumber = useSelector(getRoundNumber)
  const [isPrizePoolBottomSheetOpen, setIsPrizePoolBottomSheetOpen] = useState<boolean>(false);
  const [isQuickGuideBottomSheetOpen, setIsQuickGuideBottomSheetOpen] = useState<boolean>(false);
  const [isSettingBottomSheetOpen, setIsSettingBottomSheetOpen] = useState<boolean>(false);
  const [isLeaveTableBottomsheetOpen, setIsLeaveTableBottomsheetOpen] = useState<boolean>(false);
  const [isTooltipTimeout, setIsTooltipTimeout] = useState<boolean>(false);
  

  const handleLeaveGameClick = useCallback(() => {
    // handleLeaveGame()
    setIsSettingBottomSheetOpen(false);
    setIsLeaveTableBottomsheetOpen(true);
  }, [])

  // const handleYesClick = useCallback(() => {
  //   handleLeaveGame()
  //   closeBottomsheet()
  // }, [])

  useEffect(()=> {
    const timer = setTimeout(() => {
      setIsTooltipTimeout(true)
    }, 5000);
    return ()=> clearInterval(timer);
  },[]);

  return (
    <>
      <header className={clsx(styles.headerWrapper)}>
        <div className={clsx(styles.leftBlock, styles.connectivityStatusBlock)}>
          {normalizedStatus === "good" ? (
            <WifiIcon />
          ) : normalizedStatus === "no network" ? (
            <NoInternetIcon />
          ) : (
            <div className={clsx(styles.weakInternetWrapper,"flex alignItemCenter justifyContentFS")}>
              <WeakInternetIcon />
              {!isTooltipTimeout && (
              <div className={clsx(styles.tooltip, styles.slideDown, "fontSizeSm12 fontWeightBolder flex alignItemCenter")}>{t("pleaseMoveToAnAreaWithBetterSignal")} </div>
              )}
            </div>
          )}
        </div>
        <div className={clsx(styles.centerBlock, styles.prizePoolBlock, "flex alignItemCenter justifyContentCenter")} onClick={() => setIsPrizePoolBottomSheetOpen(true)}>
          <GoldTrophyIcon />
          <span className={clsx(styles.label, "fontColorWhite fontWeightBold fontSizeXs")}>{t("prizePool")}</span>
          {(!_isNil(prizePot) || !_isNil(roundNumber)) && (
            <span className={clsx(styles.prizeMoney, "fontColorWhite fontWeightBold fontSizeSm12")}>{_isNil(roundNumber) ? `${RUPEES_SYMBOL}${prizePot}` : roundNumber}</span>
          )}
        </div>
        <div className={clsx(styles.rightBlock, styles.actionButtonsBlock)}>
          <div className={clsx(styles.guideBox)} onClick={() => setIsQuickGuideBottomSheetOpen(true)}>
            <GuideIcon />
          </div>
          <div className={clsx(styles.settingBox)} onClick={() => setIsSettingBottomSheetOpen(true)}>
            <SettingIcon />
          </div>
        </div>
      </header>

      <QuickGuideBottomsheet
        isOpen={isQuickGuideBottomSheetOpen}
        onClose={() => setIsQuickGuideBottomSheetOpen(false)}
      />

      <PrizePoolBottomsheet
        isOpen={isPrizePoolBottomSheetOpen}
        onClose={() => setIsPrizePoolBottomSheetOpen(false)}
      />

      <SettingsBottomsheet
        isOpen={isSettingBottomSheetOpen}
        onClose={() => setIsSettingBottomSheetOpen(false)}
        handleLeaveGameClick={handleLeaveGameClick}
      />

      <LeaveTableBottomsheet
        isOpen={isLeaveTableBottomsheetOpen}
        onClose={() => setIsLeaveTableBottomsheetOpen(false)}
      />

    </>
  )
}
export default GameplayHeader;